<template>
  <element>
    <AppBar :title="title" />
    <v-container class="pt-0">
      <v-icon class="page-icon" color="#2e384d" size=60>mdi-car</v-icon>
      <p class="desc">{{ $t('selectCar.description') }}</p>
      <section class="d-flex flex-column mt-3">
        <v-select
            :items="cars"
            label="Bílar"
            :open-on-clear=true
            :outlined=true
            :rounded=true
            :clearable=true
            item-value="car_id"
            @change="selectionChanged"
          >
          
            <template slot="selection" scope="data">
                  {{ data.item.vin ? data.item.vin:data.item.license_plate_number }}
            </template>

            <template v-slot:item="{ item }">
                <b-container style="padding-left:0px">
                    <b-row no-gutters align-h="start">
                        <b-col cols="2" class="mr-0">
                            <img class="car-image" :src="'/api/v1/CarDocuments/get?is_thumb=1&raw=1&get_first=1&document_type_id=1&car_id=' + item.car_id" onerror="this.style.visibility='hidden'">
                        </b-col>
                        <b-col cols="6">
                            <b-row no-gutters align-h="start" style="text-align:left">
                                <b-col cols="12">                 
                                    <small>{{ item.license_plate_number }}</small>
                                </b-col>
                            </b-row>
                            <b-row no-gutters align-h="start" style="text-align:left">
                                <b-col cols="12" >  
                                    {{ item.vin }}
                                </b-col>
                            </b-row>
                        </b-col>
                        <b-col cols="4" style="text-align:right">
                            <b-row no-gutters align-h="end">
                                <b-col cols="12">
                                    <small><b-badge variant="primary" class="mr-1">{{ item.status }}</b-badge></small>
                                    <small><b-badge variant="dark"> {{ item.reg_date }}</b-badge></small>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                </b-container>
            </template>
           
          </v-select>
      </section>
      <v-btn
        class="white--text"
        color="#033e8c"
        height="45px"
        block
        @click="complete"
        :disabled="disableCompleteButton"
      >
        {{ completeBtnTitle }}
      </v-btn>
    </v-container>
  </element>
</template>

<script>
import AppBar from "@/components/common/AppBar.vue"

export default {
  name: "SelectCar",
  props: {},
  components: {
    AppBar
  },
  data() {
    return {
        selectedCar:null,
        car_status:null,
        cars:null
    }
  },
  created(){
    this.title = this.$store.getters.getCurrentTask.taskName
    // td 202009150255 we retrieve process variables, and if we find a car_status variable
    // we include its content as a parameter for the retrieveCars call
    const pid = this.$store.getters.getCurrentPID
    this.$store.dispatch('retrieveProcessVariables', pid)
    .then(response => {
      try {
        this.car_status = response.data.data.car_status.value
        this.retrieveCars(this.car_status)
      } catch (error) {
        console.log("Failed retrieving variables from API.", error)
        this.retrieveCars(null)
      }
    })
  },

  methods: {
      selectionChanged(car_id)
      {
          console.log(`selected car ${car_id}`)
          this.selectedCar=car_id
      },
      complete() {
      const variables = {
        "variables": {
          "car_id": {
            "value": this.selectedCar,
            "type": "Integer"
          }
        }
      }
      
      const taskId = this.$store.getters.getCurrentTask?.id

      if (taskId) {
        this.$store.dispatch('completeTask', { taskId, variables })
        .then(response => {
          console.log("Task completed successfully!", taskId, response)
        })
        .catch(error => {
          console.log("Failed completing task!", taskId, error)
        })
      }
    },
    
    retrieveCars(car_status)
    {
      let url=null
      if (car_status != null)
      {
        url=`/Cars/get?status=${car_status}`
      } else {
        url=`/Cars/get`
      }
      this.axios.get(url, {}, { withCredentials: true })
      .then(response => {
        console.log("response data", response.data.data)
        this.cars=response.data.data
      })
      .catch(error => {
        console.log("Failed retrieving cars", error)
      })
    }
  },

  computed: {
    disableCompleteButton: function () {
      if (this.selectedCar!=null && this.selectedCar!=undefined)
          return false
      else
          return true
    },
    completeBtnTitle()
    {
      return this.$store.getters.getCurrentTask.taskName
    }      

  },

  watch: {

  }
}
</script>

<style scoped>
.car-image {
    width: 45px;
    height: 45px;
    object-fit: cover;
    border: 1px solid #BFC5D2;
    box-sizing: border-box;
    border-radius: 6px;
    }

.white--text {
  color: white !important;
}
</style>
